import { postFunctionJson } from "./functionHttp";

const SET_USER_STATUS_URL =
  "https://us-central1-deliveryapp-c1bf2.cloudfunctions.net/setUserStatus";

export async function setTeamUserStatus(firebaseUser, targetUserId, status) {
  if (!firebaseUser?.getIdToken) {
    throw new Error("Missing signed-in user.");
  }

  if (!targetUserId) {
    throw new Error("Missing target user id.");
  }

  if (!status) {
    throw new Error("Missing status.");
  }

  const authToken = await firebaseUser.getIdToken(true);
  const response = await postFunctionJson(SET_USER_STATUS_URL, {
    authToken,
    body: {
      authToken,
      targetUserId,
      status,
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.success !== true) {
    throw new Error(data?.error || "Failed to update user status.");
  }

  return data;
}
